// Mantine
import { Modal, Button } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function FulfillmentOrderClose({ fulfillment_order, reload }) {
    // Modal state
    const [opened, { open, close }] = useDisclosure(false)

    const { requestPost, loading } = useAxiosApi()

    const markAsCanceled = async () => {
        await requestPost(`/fulfillment-orders/${fulfillment_order.id}/cancel`)
        reload()
    }

    if (fulfillment_order.status === 'OPEN') {
        return (
            <>
                <Modal
                    title="Confirmer l'annulation de la demande"
                    opened={opened}
                    onClose={close}
                >
                    <div className="flex flex-col gap-5">
                        <span>
                            Êtes-vous sûr de vouloir annuler la demande de
                            préparation{' '}
                            <strong>BP{fulfillment_order.id}</strong> ?
                        </span>

                        <div className="grid grid-cols-2 gap-3">
                            <Button variant="default" onClick={close}>
                                Annuler
                            </Button>

                            <Button loading={loading} onClick={markAsCanceled}>
                                Marquer comme annulée
                            </Button>
                        </div>
                    </div>
                </Modal>

                <Button onClick={open}>Annuler la demande</Button>
            </>
        )
    }
}
